// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","viewAsSelect":"_10PgEIIcVpj9izcjhl7gR3","returnIcon":"_3HA3_d2JX6arz0kjiVKoUg"};